import 'blueimp-load-image';
import 'blueimp-canvas-to-blob';
import 'blueimp-file-upload';
import 'blueimp-tmpl/js/tmpl.min.js';
import 'blueimp-file-upload/js/jquery.fileupload-ui';
export const tmpl = require('blueimp-tmpl/js/tmpl.min.js');
